export const BUSINESS_CATEGORY_CONFIG = [
  {
    name: 'Pet Grooming',
    description: 'Take online bookings, reduce no-shows, and keep your calendar full',
    icon: 'Grooming',
    link: `/business/pet-grooming`,
  },
  {
    name: 'Dog Walking',
    description: 'Let owners book walks online and get discovered via Pata Marketplace',
    icon: 'DogWalking',
  },
  {
    name: 'Pet Sitting',
    description: 'Simplify sitter bookings and attract new clients in your area',

    icon: 'Sitting',
  },
  {
    name: 'Pet Training',
    description: 'Schedule training sessions and build your client base',

    icon: 'Training',
    link: `/business/dog-training`,
  },
  {
    name: 'Veterinary',
    description: 'Accept bookings online and reduce admin with fewer calls',

    icon: 'Vet',
  },
  {
    name: 'Pet Boarding',
    description: 'Handle bookings, check-ins, & payments all in one place',

    icon: 'Boarding',
  },
  {
    name: 'Pet Cremation',
    description: 'Offer compassionate services with minimal admin',

    icon: 'PetCremation',
  },
  {
    name: 'Grief Counselling',
    description: 'Provide discreet session bookings with automated reminders',

    icon: 'GriefCounselling',
  },
  {
    name: 'Canine Hydrotherapy',
    description: 'Let clients book therapy sessions and access key service info',
    icon: 'PetHydrotheraphy',
    link: `/business/canine-hydrotherapy`,
  },
  {
    name: 'Massage Therapy',
    description: 'Take online bookings and avoid back-and-forth messaging',
    icon: 'PetMassage',
  },
  {
    name: 'Dog Exercise Field',
    description: 'Take bookings, manage visits, & stay organised with ease',
    icon: 'DogPark',
  },
  {
    name: 'Pet Transportation',
    description: 'Let clients schedule safe, reliable pet transport in a few taps',
    icon: 'PetTransportation',
  },
  {
    name: 'Pet Photography',
    description: 'Let clients book photo shoots & leave reviews online',
    icon: 'Photography',
  },
  {
    name: 'Pet Services',
    description: 'List, manage, and take bookings for pet services you offer',
    icon: 'PetService',
  },
];
